// src/pages/ProfileEdit/medicalHistoryTourConfig.js

export const medicalHistoryTourSteps = [
    {
        popover: {
            title: '👋 Bienvenue sur l\'Historique Médical',
            description: 'Je vais vous guider à travers toutes les sections pour gérer vos antécédents médicaux.',
            side: 'over',
        },
    },
    {
        element: '.pe-side',
        popover: {
            title: '📋 Barre Latérale',
            description: 'Utilisez ce menu pour naviguer entre les différentes sections de modification de votre profil.',
            position: 'right',
        },
    },
    {
        element: '.pe-avatar',
        popover: {
            title: '📸 Photo de Profil',
            description: 'Cliquez sur l\'icône de crayon pour modifier votre photo de profil.',
            position: 'right',
        },
    },
    {
        element: '.pe-menu',
        popover: {
            title: '🗂️ Menu de Navigation',
            description: 'Trois sections disponibles : Informations Générales, Historique Médical, et Assurance/Urgence.',
            position: 'right',
        },
    },
    {
        element: '.pe-item.is-active',
        popover: {
            title: '🏥 Section Active',
            description: 'Vous êtes actuellement dans la section Historique Médical où vous pouvez gérer vos habitudes de vie, allergies, chirurgies et antécédents familiaux.',
            position: 'right',
        },
    },
    {
        element: '.pe-content1',
        popover: {
            title: '📝 Formulaire d\'Historique',
            description: 'Cette zone contient tous les formulaires pour gérer votre historique médical complet.',
            position: 'center',
        },
    },
    {
        element: '.pe-footer',
        popover: {
            title: '💾 Actions de Sauvegarde',
            description: 'Utilisez ces boutons pour annuler ou sauvegarder vos modifications.',
            position: 'top',
        },
    },
    {
        element: '.pe-discard',
        popover: {
            title: '❌ Annuler',
            description: 'Cliquez ici pour annuler toutes les modifications et revenir à la page précédente.',
            position: 'top',
        },
    },
    {
        element: '.pe-save',
        popover: {
            title: '✅ Sauvegarder',
            description: 'Cliquez sur ce bouton pour enregistrer définitivement toutes les modifications apportées à votre historique médical.',
            position: 'top',
        },
    },
    {
        popover: {
            title: '🎉 Tour Terminé !',
            description: 'Vous savez maintenant comment naviguer dans la page d\'édition. Une fois que vous m\'envoyez le composant du formulaire, je pourrai ajouter des étapes plus détaillées !',
            side: 'over',
        },
    },
];